<template>
  <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
    content-class="deposit-withdraw-popup">
    <template v-slot:activator="{ on, attrs }">
      <span class="text-decoration-none" v-bind="attrs" v-on="on">Change Password</span>
    </template>
    <!-- Dialog content goes here -->
    <v-card class="rounded-0 pa-7 " :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
      <v-card-title class="pb-3 text-left justify-start pl-3">
        Change Password
      </v-card-title>
      <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
        Change Your Login Password From Here
      </v-card-subtitle>
      <v-card class="deposit-form px-3 py-4" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
        <v-row>
          <v-col cols="12">
            <fieldset>
              <legend>Email</legend>
              <v-text-field type="email" :label="personalinfo.email" disabled single-line solo hide-details
                class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Password</legend>
              <v-text-field label="Write New Password" v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" counter
                @click:append="show1 = !show1" single-line solo hide-details class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
          <v-col cols="12">
            <fieldset>
              <legend>Confirm Password</legend>
              <v-text-field v-model="confirm_password" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'" counter @click:append="show2 = !show2"
                label="Write New Password Again" single-line solo hide-details class="custom-select"></v-text-field>
            </fieldset>
          </v-col>
        </v-row>
      </v-card>
      <v-card-actions>
        <v-row dense>
          <v-col cols="12">
            <v-btn tile @click="handleConfirm" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
              color="greenMain">Confirm</v-btn>
            <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
              class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { REGISTERUSERDETAILS__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      dialogDeposit: false,
      show1: false,
      show2: false,
      email: "",
      password: "",
      confirm_password: "",
      userId: ""
    };
  },
  computed: {
    ...mapState("reguserdetails", ["personalinfo"]),
  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTLOGINPASSWORD, REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO]),
    handleConfirm() {
      this[REGISTERUSERDETAILS__ACTIONS.CHANGECLIENTLOGINPASSWORD]({
        userId: this.userId,
        email: this.personalinfo.email,
        password: this.password,
        confirm_password: this.confirm_password,
      })
      this.dialogDeposit = false;
    },
  },

  async mounted() {
    this.userId = this.$route.params.id
    await this[REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO](this.$route.params.id);
  },
};
</script>